module.exports = __webpack_public_path__ + "img/logo.2b42687c.png";